import { NSARouterMakerResult } from "namirasoft-account-react";
import { NSMenuActionProps } from "namirasoft-site-react";
import { InferenceChatTargetType, InferenceRoutes } from "./InferenceRoutes";

export class InferenceMenus
{
    static chatWithModel(props: NSARouterMakerResult, getIDs: () => string[]): NSMenuActionProps
    {
        return {
            id: "1",
            menu_item: "New Chat",
            isActive: () => getIDs().length === 1,
            onClick: {
                action: (onFinished) =>
                {
                    let model_id = getIDs()[0];
                    props.url.redirect(InferenceRoutes.ChatNew(InferenceChatTargetType.Model, model_id), {});
                    onFinished();
                }
            }
        };
    }
    static chatWithLoadBalancer(props: NSARouterMakerResult, getIDs: () => string[]): NSMenuActionProps
    {
        return {
            id: "1",
            menu_item: "New Chat",
            isActive: () => getIDs().length === 1,
            onClick: {
                action: (onFinished) =>
                {
                    let load_balancer_id = getIDs()[0];
                    props.url.redirect(InferenceRoutes.ChatNew(InferenceChatTargetType.LoadBalancer, load_balancer_id), {});
                    onFinished();
                }
            }
        };
    }
    static chatWithFailover(props: NSARouterMakerResult, getIDs: () => string[]): NSMenuActionProps
    {
        return {
            id: "1",
            menu_item: "New Chat",
            isActive: () => getIDs().length === 1,
            onClick: {
                action: (onFinished) =>
                {
                    let failover_id = getIDs()[0];
                    props.url.redirect(InferenceRoutes.ChatNew(InferenceChatTargetType.Failover, failover_id), {});
                    onFinished();
                }
            }
        };
    }
    static chatWithRace(props: NSARouterMakerResult, getIDs: () => string[]): NSMenuActionProps
    {
        return {
            id: "1",
            menu_item: "New Chat",
            isActive: () => getIDs().length === 1,
            onClick: {
                action: (onFinished) =>
                {
                    let race_id = getIDs()[0];
                    props.url.redirect(InferenceRoutes.ChatNew(InferenceChatTargetType.Race, race_id), {});
                    onFinished();
                }
            }
        };
    }
    static chatWithRouter(props: NSARouterMakerResult, getIDs: () => string[]): NSMenuActionProps
    {
        return {
            id: "1",
            menu_item: "New Chat",
            isActive: () => getIDs().length === 1,
            onClick: {
                action: (onFinished) =>
                {
                    let router_id = getIDs()[0];
                    props.url.redirect(InferenceRoutes.ChatNew(InferenceChatTargetType.Router, router_id), {});
                    onFinished();
                }
            }
        };
    }
    static chatWithGateway(props: NSARouterMakerResult, getIDs: () => string[]): NSMenuActionProps
    {
        return {
            id: "1",
            menu_item: "New Chat",
            isActive: () => getIDs().length === 1,
            onClick: {
                action: (onFinished) =>
                {
                    let gateway_id = getIDs()[0];
                    props.url.redirect(InferenceRoutes.ChatNew(InferenceChatTargetType.Gateway, gateway_id), {});
                    onFinished();
                }
            }
        };
    }
}